import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { APP_CONSTANTS } from '../../core/constants/app.constants';
import { AuthService } from '../../core/Provider/auth.service';

@Component({
  selector: 'app-staff-portal-preview-bar',
  standalone: true,
  templateUrl: './staff-portal-preview-bar.component.html',
  styleUrl: './staff-portal-preview-bar.component.scss'
})
export class StaffPortalPreviewBarComponent implements OnInit {
  private router = inject(Router);
  private authService = inject(AuthService);
  private destroyRef = inject(DestroyRef);

  visible = false;

  ngOnInit(): void {
    this.syncVisibility();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.syncVisibility());
  }

  onBackToCrm(): void {
    const returnTo = this.authService.exitStaffStudentPreview();
    void this.router.navigateByUrl(returnTo);
  }

  private syncVisibility(): void {
    const onStudentPortal = this.router.url.includes(APP_CONSTANTS.ROUTES.STUDENT_DASHBOARD);
    this.visible = onStudentPortal && this.authService.isStaffPortalPreviewActive();
  }
}
